import { useEffect, useState } from "react";
import FilterComponent from "./components/FilterComponent";
import StatsComponent from "./components/StatsComponent";
import { CustomLoader, decruptCipher } from "../../Services/CommonLibrary";
import ChartsSection from "./components/ChartsSection";
import {
  ServiceAllprogramList,
  serviceDivisionPractice,
  servicePatientData,
  serviceSuperviewActiveUserCount,
  serviceSuperviewCallDetail,
  serviceSuperviewCoachRating,
  serviceSuperviewInclinicCall,
  serviceSuperviewMesageGraph,
  serviceSuperviewUserCount,
  serviceSuperviewUserDivisionCount,
  serviceSuperviewUserDivisionDateCount,
  serviceSuperviewUserDivisionPracticeCount,
  serviceSuperviewUserProgramCount,
} from "../../Services/Service";
import { defaultOneMonthDate } from "../../Services/commonFun";
// import ChartsSection from "./components/ChartsSection";

export default () => {
  const { today, lastMonth } = defaultOneMonthDate();
  const [filterForm, setFilterForm] = useState({
    startRange: lastMonth,
    endRange: today,
    programSelect: "",
    divisionSelected: [],
    clinicSelect: [],
    divisionClinicFilter: {
      clinic: [],
      division: [],
    },
  });

  const color = ["#fa43b7", "#43c3fa"];
  const programmeColors = [
    "#10B981",
    "#DC2626",
    "#EF4444",
    "#F59E0B",
    "#8B5CF6",
    "#EC4899",
    "#06B6D4",
    "#a53232ff",
    "#6366F1",
    "#dd620aff",
    "#D946EF",
    "#335b94ff",
    "#F87171",
  ];
  const inclinicColors = ["#F97316", "#3B82F6", "#EF4444", "#10B981", "#69470dff", "#9333ea", "#F97316"]; 
  const dailyCategorization = ["#007bff", "#28a745"];     //Accouint Created: '#007bff', 'Fully onboarded': '#28a745'
  const callDetails = ["#FF9900", "#28a745","#6c757d","#CC0000","#ca5151ff", "#007bff"];   //Incomplete: '#FF9900', Completed: '#28a745', Cancelled: '#6c757d', Missed: '#CC0000', In-Progress: '#292d31ff', Unsuccessfull: '#007bff'
  const messageDetails = ["#77c25aff", "#0b7030ff", "#9333ea"]; //'Coach Sent/User Received': '#e11d48', 'User Sent/Coach Received': '#16a34a', 'Expert Sent/Player Received': '#9333ea'
  const ageColorsDetails = ["#4CAF50", "#2196F3", "#FFC107", "#E91E63"];
  const [userData, setUserData] = useState({
    onboarded: 0,
    notonboarded: 0,
    total: 0,
    loggedIn: 0,
    inclinic: 0,
    completedCalls: 0,
    inactiveUsers: 0,
    firstCall: 0,
    deleteCount: 0,
    opt_out_count: 0,
  });

  const [seriesGraph, setSeriesGraph] = useState({
    program_graph_series: {},
    gender_graph_series: {},
    age_graph_series: {},
    divisionCategory: [],
    divisionSeries: [],
    divisionDateCategory: [],
    divisionDateSeries: [],
    inclinicCallSeries: [],
    callDetailCategory: [],
    callDetailSeries: [],
    mesageGraphCategory: [],
    mesageGraphSeries: [],
    divisionPracticeCategory: [],
    divisionPracticeSeries: [],
    programmesList: [],
    loadingStates: {
      program_graph: true,
      gender_age_graph: true,
      division_graph: true,
      division_practice_graph: false,
      division_date_graph: true,
      inclinic_call_graph: true,
      call_detail_graph: true,
      message_graph: true,
    },
  });

  const [startRange, setStartRange] = useState("");
  const [endRange, setEndRange] = useState("");
  const [dateFilter, setDateFilter] = useState([]);
  // const [divisionClinicFilter, setDivisionClinicFilter] = useState({
  //   division: [],
  //   clinic: [],
  // });
  const [activeUsers, setActiveUsers] = useState({});
  const [graphDuration, setGraphDuration] = useState("Daily ");
  const [coachRatingData, setCoachRatingData] = useState([]);
  const [coachRatingLoading, setCoachRatingLoading] = useState(false);
  const [programSelect, setProgramSelect] = useState("");
  const [showInclinic, setShowInclinic] = useState(0);
  const [activeUsersLoading, setActiveUsersLoading] = useState(false);
  const [isMount, setIsMount] = useState(false);
  const [fetchServicePatientDataLoading, setFetchServicePatientDataLoading] =
    useState(false);
  const [fetchSuperviewCallDetailLoading, setFetchSuperviewCallDetailLoading] =
    useState(false);
  const [
    fetchSuperviewMesageGraphLoading,
    setFetchSuperviewMesageGraphLoading,
  ] = useState(false);
  const [
    fetchSuperviewInclinicCallLoading,
    setfetchSuperviewInclinicCallLoading,
  ] = useState(false);

  const [programData, setProgramData] = useState([]);

  var company = localStorage.getItem("company")
    ? localStorage.getItem("company")
    : 0;
  const companyId = decruptCipher(company);

  function appendUniqueValue(arr, value) {
    const existingIndex = arr.findIndex((item) => item === value);
    if (existingIndex !== -1) {
      arr[existingIndex] = value;
    } else {
      arr.push(value);
    }
    return arr;
  }

  let divisionArr = [];
  let clinicArr = [];
  const assignObjectPaths = (obj, stack) => {
    Object.keys(obj || {}).forEach((k) => {
      const node = obj?.[k];
      if (node?.type == "parent") {
        divisionArr = appendUniqueValue(divisionArr, node?.value);
      }
      if (node?.type == "child") {
        clinicArr = appendUniqueValue(clinicArr, node?.value);
      }

      if (typeof node === "object") {
        node.path = stack ? `${stack}.${k}` : k;
        assignObjectPaths(node, node.path);
      }
    });
  };

  const formatter = new Intl.NumberFormat("en-IN");

  useEffect(() => {
   let  id=null;
   console.log(isMount)
    if (isMount) {
      const jobs = [
        fetchActiveUser,
        fetchServicePatientData,
        fetchSuperviewCallDetail,
        fetchSuperviewMesageGraph,
        fetchSuperviewInclinicCall,
        // fetchProgram,
        fetchCoachRating,
        fetchSuperviewUserProgramCount,
        fetchSuperviewUserDivisionPracticeCount,
        fetchSuperviewUserDivisionDateCount,
        fetchSuperviewUserDivisionCount,
        fetchSuperviewUserCount,
      ];
      let i = 0;
       id = setInterval(() => {
        if (i >= jobs.length) {
          clearInterval(id);        // everything scheduled
          return;
        }
        jobs[i++]();                // fire‑and‑forget 🚀
      }, 500);
    } else {
      setIsMount(true);
    }
    // cleanup if the component unmounts
    return () => { clearInterval(id); };
  }, [filterForm]);


  // const divisionClinicFilter = filterForm.divisionClinicFilter;

  const fetchSuperviewUserProgramCount = async () => {
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        program_graph: true,
      },
    }));
    try {
      await serviceSuperviewUserProgramCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        setSeriesGraph((prevState) => ({
          ...prevState,
          program_graph_series: res?.data?.data?.series || {},
          loadingStates: {
            ...prevState.loadingStates,
            program_graph: false,
          },
        }));
      });
    } catch (error) {
      console.error("Error fetching program data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          program_graph: false,
        },
      }));
    }
  };

  const fetchSuperviewUserDivisionPracticeCount = async () => {
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        division_practice_graph: true,
      },
    }));
    try {
      await serviceSuperviewUserDivisionPracticeCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        // console.log(res);
        if (res?.data?.status == 1) {
          console.log(res.data.data);
          setSeriesGraph((prevState) => ({
            ...prevState,
            divisionPracticeCategory: res?.data?.data?.category || [],
            divisionPracticeSeries: res?.data?.data?.series || [],
          }));
        } else {
          setSeriesGraph((prevState) => ({
            ...prevState,
            divisionPracticeCategory: [],
            divisionPracticeSeries: [],
            loadingStates: {
              ...prevState.loadingStates,
              division_practice_graph: false,
            },
          }));
        }
      });
    } catch (error) {
      console.error("Error fetching division practice data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        divisionPracticeCategory: [],
        divisionPracticeSeries: [],
        loadingStates: {
          ...prevState.loadingStates,
          division_practice_graph: false,
        },
      }));
    } finally {
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          division_practice_graph: false,
        },
      }));
    }
  };

  const fetchSuperviewUserDivisionDateCount = async () => {
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        division_date_graph: true,
      },
    }));
    try {

      await serviceSuperviewUserDivisionDateCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        setSeriesGraph((prevState) => ({
          ...prevState,
          divisionDateCategory: res?.data?.data?.category || [],
          divisionDateSeries: res?.data?.data?.series || [],
          loadingStates: {
            ...prevState.loadingStates,
            division_date_graph: false,
          },
        }));
        setGraphDuration(res?.data?.graphDuration);
      });
    } catch (error) {
      console.error("Error fetching division date data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          division_date_graph: false,
        },
      }));
    }
  };

  const fetchSuperviewUserDivisionCount = async (type='') => {
    setSeriesGraph((prevState) => ({
      ...prevState,
      loadingStates: {
        ...prevState.loadingStates,
        division_graph: true,
      },
    }));
    try {

      await serviceSuperviewUserDivisionCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect,
        type
      ).then((res) => {
        
        setSeriesGraph((prevState) => ({
          ...prevState,
          new_data:res?.data?.new_data??[],
          new_data_2:res?.data?.new_data_2??[],
          divisionCategory: res?.data?.data?.category || [],
          divisionSeries: res?.data?.data?.series || [],
          loadingStates: {
            ...prevState.loadingStates,
            division_graph: false,
          },
        }));
      });
    } catch (error) {
      console.error("Error fetching division data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          division_graph: false,
        },
      }));
    }
  };

  const fetchSuperviewUserCount = async () => {
    setSeriesGraph((prevState) => ({
      ...prevState,
      gender_graph_series: {},
      age_graph_series: {},
      loadingStates: {
        ...prevState.loadingStates,
        gender_age_graph: true,
      },
    }));
    try {
      await serviceSuperviewUserCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        setUserData((prevState) => ({
          ...prevState,
          // onboarded: parseInt(res?.data.data[0].onboardedUser),
          // total: parseInt(res?.data.data[0].total),
          loggedIn: parseInt(res?.data?.data?.[0]?.loggedInUser),
          notonboarded: parseInt(res?.data?.data?.[0]?.notonboardedUser),
          inclinic: parseInt(res?.data?.data?.[0]?.inclinic),
          //completedCalls: parseInt(res?.data.data[0].completedCalls),
          inactiveUsers: parseInt(res?.data?.data?.[0]?.inactiveUsers),
          firstCall: parseInt(res?.data?.data?.[0]?.firstCallUser),
        }));
        setSeriesGraph((prevState) => ({
          ...prevState,
          gender_graph_series: res?.data?.data?.[0]?.gender_series || {},
          age_graph_series: res?.data?.data?.[0]?.age_series || {},
          loadingStates: {
            ...prevState.loadingStates,
            gender_age_graph: false,
          },
        }));
      });
    } catch (error) {
      console.log("Error fetching user count data", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        gender_graph_series: {},
        age_graph_series: {},
        loadingStates: {
          ...prevState.loadingStates,
          gender_age_graph: false,
        },
      }));
    }
  };

  const fetchProgram = async () => {
    // await ServiceAllprogramList().then((res) => {
    //   setProgramData(res?.data?.data || []);
    // });
  };
  const fetchCoachRating = async () => {
    setCoachRatingLoading(true);
   
    await serviceSuperviewCoachRating(
       filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
    ).then((res) => {
      // console.log(res?.data.data);
      setCoachRatingData(res?.data?.data || []);
      // console.log(coachRatingData)
    });
    setCoachRatingLoading(false);
  };


  //  const fetchDivsionPractice = async () => {
  //      await serviceDivisionPractice().then((res) => {
  //        if (res?.data?.code == 200) {
  //          assignObjectPaths(res?.data?.data);
  //          setDivisionClinicFilter((prevState) => ({
  //            ...prevState,
  //            clinic: clinicArr,
  //            division: divisionArr,
  //          }));
  //          setDivisionPracticeData([
  //            {
  //              label: "Select All",
  //              value: "toggleSelectAll",
  //              _toggleSelectAll: true,
  //              checked: true,
  //            },
  //            ...(res?.data?.data || []),
  //          ]);
  //        }
  //      });
  //    };

  //
  const fetchActiveUser = async () => {
    setActiveUsersLoading(true);

    try {
      await serviceSuperviewActiveUserCount(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        setActiveUsers(res?.data);
        //   setActiveUserDetails(res.data.data);
      });
    } catch (e) {
      console.log(e?.message);
    } finally {
      setActiveUsersLoading(false);
    }
  };



  const fetchServicePatientData = async () => {
    setFetchServicePatientDataLoading(true);
    try {
      await servicePatientData(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        // console.log(res?.data.data, "patient data")
        setUserData((prevState) => ({
          ...prevState,
          notLogin: res?.data?.data?.notLogin ?? 0,
          partialOnboard: res?.data?.data?.partialOnboard ?? 0,
          onboarded: res?.data?.data?.onboarded ?? 0,
          total: res?.data?.data?.total ?? 0,
          deleteCount: res?.data?.data?.deleteCount ?? 0,
        }));
      });
    } catch (e) {
      console.log(e?.message);
    } finally {
      setFetchServicePatientDataLoading(false);
    }
  };

  const fetchSuperviewCallDetail = async () => {
    setFetchSuperviewCallDetailLoading(true);
    try {
      await serviceSuperviewCallDetail(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        const series = res?.data?.data?.series || []; // Default to an empty array if series is null/undefined
        const calldata = res?.data?.callData || {}; // Default to an empty array if series is null/undefined


        setUserData((prevState) => ({
          ...prevState,
          incompleteCalls: formatter.format(calldata?.incomplete || 0),
          completedCalls: formatter.format(calldata?.completed || 0),
          missedCalls: formatter.format(calldata?.missed || 0),
          cancelledCalls: formatter.format(calldata?.cancelled || 0),
          unsuccessfulCalls: formatter.format(calldata?.unsuccessfull || 0),
          scheduledCalls: formatter.format(calldata?.scheduled),
        }));

        setSeriesGraph((prevState) => ({
          ...prevState,
          callDetailCategory: res?.data?.data?.category || [], // Handle empty category
          callDetailSeries: series, // Use the (possibly empty) series array
          loadingStates: {
            ...prevState.loadingStates,
            call_detail_graph: false,
          },
        }));

        setGraphDuration(res?.data?.graphDuration || null); // Default to null if not present
      });
    } catch (error) {
      console.error("Error fetching call detail data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          call_detail_graph: false,
        },
      }));
    } finally {
      setFetchSuperviewCallDetailLoading(false);
    }
  };

  const fetchSuperviewMesageGraph = async () => {
    setFetchSuperviewMesageGraphLoading(true);
    try {
      await serviceSuperviewMesageGraph(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        const series = res?.data?.data?.series;
        const formatter = new Intl.NumberFormat("en-UK");
        // Calculate totals from mesageGraphSeries
        const messageTotals = series
          ? series.reduce((acc, item) => {
            acc[item?.name?.toLowerCase()] = item?.data?.reduce(
              (sum, value) => sum + value,
              0
            );
            return acc;
          }, {})
          : {};

        // Calculate the total of all messages
        const totalMessages = Object.values(messageTotals).reduce(
          (sum, value) => sum + value,
          0
        );

        setUserData((prevState) => ({
          ...prevState,
          coachSentUserReceived: formatter.format(
            messageTotals?.["coach sent/user received"] || 0
          ),
          userSentCoachReceived: formatter.format(
            messageTotals?.["user sent/coach received"] || 0
          ),
          expertSentPlayerReceived: formatter.format(
            messageTotals?.["expert sent/player received"] || 0
          ),
          totalMessages: formatter.format(totalMessages), // Add the total of all messages
        }));
        setSeriesGraph((prevState) => ({
          ...prevState,
          mesageGraphCategory: res?.data?.data?.category || [],
          mesageGraphSeries: res?.data?.data?.series || [],
          loadingStates: {
            ...prevState.loadingStates,
            message_graph: false,
          },
        }));
        setGraphDuration(res?.data?.graphDuration);
      });
    } catch (error) {
      console.error("Error fetching message data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          message_graph: false,
        },
      }));
    } finally {
      setFetchSuperviewMesageGraphLoading(false);
    }
  };

  const fetchSuperviewInclinicCall = async () => {
    setfetchSuperviewInclinicCallLoading(true);
    try {
      await serviceSuperviewInclinicCall(
        filterForm?.startRange,
        filterForm?.endRange,
        filterForm?.divisionClinicFilter,
        filterForm?.programSelect
      ).then((res) => {
        setShowInclinic(res?.data?.status);
        if (res?.data?.status == 1) {
          setSeriesGraph((prevState) => ({
            ...prevState,
            inclinicCallSeries: res?.data?.data?.series || [],
            loadingStates: {
              ...prevState.loadingStates,
              inclinic_call_graph: false,
            },
          }));

          // Extract the count of "completed"
          const completedCount =
            res?.data?.data?.series?.data?.find(
              (item) => item?.[0] === "completed"
            )?.[1] || 0; // Fallback to 0 if not found
          // const scheduledCount = res?.data.data.series.data.find(
          //   (item) => item[0] === "scheduled"
          // )?.[1] || 0; // Fallback to 0 if not found
          const totalCount = res?.data?.data?.series?.data?.reduce(
            (sum, item) => sum + (item?.[1] || 0),
            0
          );
          setUserData((prevState) => ({
            ...prevState,
            completedInClinicCount: completedCount,
            scheduledInClinicCount: totalCount,
          }));
          // console.log("Count of completed:", completedCount);
          // You can now use `completedCount` as needed
        }
      });
    } catch (error) {
      console.error("Error fetching inclinic call data:", error);
      setSeriesGraph((prevState) => ({
        ...prevState,
        loadingStates: {
          ...prevState.loadingStates,
          inclinic_call_graph: false,
        },
      }));
    } finally {
      setfetchSuperviewInclinicCallLoading(false);
    }
  };

  const handleTabSelect = async (val) => {
    console.log(val);

        // await fetchSuperviewUserDivisionCount();
    // switch (val) {
    //   case 'first':
    //     break;
    //   case 'second':
    //     await fetchSuperviewUserDivisionCount('practice');
    //     break;
    //   case 'third':
    //     await fetchSuperviewUserDivisionCount('program');
    //     break;
    // };
  }
  return (
    <>
      <section className="projects-section">
        <FilterComponent
          onGo={(data) =>
            // console.log(data)
            setFilterForm((prev) => {
              return {
                ...prev,
                ...data,
              };
            })
          }
          setActiveUsersLoading={setActiveUsersLoading}
          setFetchServicePatientDataLoading={setFetchServicePatientDataLoading}
          setFetchSuperviewCallDetailLoading={setFetchSuperviewCallDetailLoading}
          setFetchSuperviewMesageGraphLoading={setFetchSuperviewMesageGraphLoading}
          setfetchSuperviewInclinicCallLoading={setfetchSuperviewInclinicCallLoading}
          setSeriesGraph={setSeriesGraph}
          setCoachRatingLoading={setCoachRatingLoading}
        />

        <StatsComponent
          filterForm={filterForm}
          companyId={companyId}
          userData={userData}
          activeUsers={activeUsers}
          activeUsersLoading={activeUsersLoading}
          fetchServicePatientDataLoading={fetchServicePatientDataLoading}
          fetchSuperviewCallDetailLoading={fetchSuperviewCallDetailLoading}
          fetchSuperviewMesageGraphLoading={fetchSuperviewMesageGraphLoading}
          fetchSuperviewInclinicCallLoading={fetchSuperviewInclinicCallLoading}

        />
        <ChartsSection
          onSelect={handleTabSelect}
          userData={userData}
          seriesGraph={seriesGraph}
          companyId={companyId}
          graphDuration={graphDuration}
          coachRatingData={coachRatingData}
          color={color}
          programmeColors={programmeColors}
          inclinicColors={inclinicColors}
          dailyCategorization={dailyCategorization}
          callDetails={callDetails}
          messageDetails={messageDetails}
          ageColorsDetails={ageColorsDetails}
          filterForm={filterForm}
          setSeriesGraph={setSeriesGraph}
          coachRatingLoading={coachRatingLoading}
        />
      </section>
    </>
  );
};
